import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { Slash } from 'lucide-react';

import { WellsFargoTransactionsTable } from './table';

export function WellsFargoTransactions() {
	const id = window.location.pathname.split('/').pop();
	const fileIngestionId = id ? parseInt(id) : NaN;
	return (
		<>
			<Breadcrumb className="mb-4 pl-4">
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbLink href="/wells-fargo">Wells Fargo Feed</BreadcrumbLink>
					</BreadcrumbItem>
					<BreadcrumbSeparator>
						<Slash />
					</BreadcrumbSeparator>
					<BreadcrumbItem>
						<BreadcrumbPage>Wells Fargo Transactions</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>

			<Card className="w-full">
				<CardHeader>
					<span className="flex flex-row justify-between">
						<CardTitle className="mt-2">Wells Fargo Transactions</CardTitle>
					</span>
					<CardDescription>File Id {fileIngestionId}</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<WellsFargoTransactionsTable fileIngestionId={fileIngestionId} />
				</CardContent>
			</Card>
		</>
	);
}
